import { Loader } from '@trackman/web-shared-components';
import { AddNewClass } from 'pages/Organization/components/Classes/AddNewClass/AddNewClass';
import { ClassList } from 'pages/Organization/components/Classes/ClassList/ClassList';
import NoClassesFound from 'pages/Organization/components/NoClassesFound/NoClassesFound';
import { useGetClasses } from 'queryHooks/Organization/Classes/useGetClasses';
import { useGetInvites } from 'queryHooks/Organization/Invites/useGetInvites';
import { useGetStudents } from 'queryHooks/Organization/Students/useGetStudents';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

export const ClassesTab = () => {
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);
  const isAddNewClassModalOpen = useOrganizationStore((state) => state.isAddNewClassModalOpen);
  const setIsAddNewClassModalOpen = useOrganizationStore((state) => state.setIsAddNewClassModalOpen);

  const { data: studentList, isPending: isStudentListPending } = useGetStudents(selectedOrganizationId);
  const { data: inviteList, isPending: isInviteListPending } = useGetInvites(selectedOrganizationId);
  const { data: classList, isPending: isClassListPending } = useGetClasses(selectedOrganizationId, false);

  return (
    <>
      {!isClassListPending && !isStudentListPending && !isInviteListPending ? (
        <>
          {classList && classList?.length > 0 && studentList && inviteList ? (
            <ClassList studentList={studentList} classList={classList} inviteList={inviteList} />
          ) : (
            <NoClassesFound />
          )}
        </>
      ) : (
        <div className='new-loader-wrapper'>
          <Loader size='large' />
        </div>
      )}
      {isAddNewClassModalOpen && <AddNewClass isOpen={isAddNewClassModalOpen} close={() => setIsAddNewClassModalOpen(false)} />}
    </>
  );
};
